import React from 'react';

import { Button, ContentWithTooltip, Group, TextArea } from '@ekhodealer/ekho-common/rev';

import './ConversationReplyComposer.scss';

/**
 * UI shell for the reply composer shown at the bottom of the message thread.
 * All inputs are disabled for v0 — actual send functionality ships in v1.
 */
export const ConversationReplyComposer = (): React.JSX.Element => (
	<div className='conversation-reply-composer'>
		<TextArea
			placeholder='Reply functionality coming soon'
			isDisabled
			rows={2}
			ariaLabel='Reply message input — coming soon'
		/>
		<Group itemsAlignX='end' itemsSpacing='8'>
			<ContentWithTooltip
				content={
					<Button size='medium' variant='filled' isDisabled ariaLabel='Send reply'>
						Send
					</Button>
				}
				tooltipContent='Human replies coming in v1'
				tooltipProps={{ placement: 'top' }}
			/>
		</Group>
	</div>
);
